// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes onAutoFillStart {\n    from {/**/}\n    to {/**/}\n}\n\n@keyframes onAutoFillCancel {\n    from {/**/}\n    to {/**/}\n}\n\ninput:-webkit-autofill {\n animation-name: onAutoFillStart;\n}\n\ninput:not(:-webkit-autofill) {\n animation-name: onAutoFillCancel;\n}\n\ninput {\n    font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
